import React from 'react'
import { Link } from 'react-router-dom';
import 'swiper/css';
import '../assets/css/style.css'
import Excellence_1 from '../assets/images/Excellence_1.png'
import job_ahgewK6 from '../assets/images/job_ahgewK6.svg'
import eligiblity_fJdL2uf from '../assets/images/eligiblity_fJdL2uf.svg'
import access_I3z9CNv from '../assets/images/access_I3z9CNv.svg'
import videos_u2JRfHI from '../assets/images/videos_u2JRfHI.svg'
import book_URipUVP from '../assets/images/book_URipUVP.svg'
import live_4eNevXX from '../assets/images/live_4eNevXX.svg'
import green_switch1 from '../assets/images/green_switch1.png'
import Img1 from '../assets/images/img.png'
import Asset_92Testimonials from '../assets/images/Asset_92Testimonials.png'
import Asset_93Testimonials from '../assets/images/Asset_93Testimonials.png'
import Asset_96Testimonials from '../assets/images/Asset_96Testimonials.png'
import Asset_98Testimonials from '../assets/images/Asset_98Testimonials.png'
import aipord1 from '../assets/images/ai-pord1.png'
import whystdy from '../assets/images/whystdy.png'
import greenTickFill from '../assets/images/greenTickFill.svg'


function CpaCoachingIndia() {
  return (
    <>
      <div className="bg-placement-hero bg-cover isolate px-6 lg:px-8 pb-8 mb-[15rem] lg:mb-20">
        <div className="h-full py-[3rem] md:py-[6rem] mx-auto text-white flex flex-col items-center justify-center">
          <div className="mx-auto lg:max-w-5xl">
            <div className="flex lg:flex-row-reverse flex-col items-center gap-12 justify-between">
              <img src={green_switch1} className="w-4/5 scale-125 md:scale-110 lg:scale-100 max-w-lg lg:block" alt="" />
              <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[90%] lg:leading-[56px]">US CPA
                Coaching in India</h1>
            </div>
            <div className="scale-90 md:scale-100 flex flex-row items-start justify-center lg:justify-start lg:pt-0 pt-4 gap-2 md:gap-6 lg:gap-8">
              <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                  className="relative lg:top-[-33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                >
                  Enquiry Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:-mt-[44px] mb-10 lg:mb-0 md:-mt-[10rem] -mt-[6rem] relative w-full flex items-center justify-center">
        <div className="lg:-mt-[7.4rem] md:-mt-[10rem] -mt-[6rem] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-10 lg:max-w-7xl">
          <div tabindex="0" className='box transform transition-transform duration-300 hover:scale-110'>
            <div className="bg-[#7F56D9] p-5 lg:h-[135px] lg:w-[135px] h-[160px] w-[160px] xl:h-[160px] xl:w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
              <p className="text-center text-sm lg:text-md pb-2 text-white">Commerce &amp; Management Graduate only</p>
              <img src={eligiblity_fJdL2uf} className="lg:h-8 h-6" />
            </div>
          </div>
          <div tabindex="0" className='box transform transition-transform duration-300 hover:scale-110'>
            <div className="bg-[#E29E35] p-5 lg:h-[135px] lg:w-[135px] h-[160px] w-[160px] xl:h-[160px] xl:w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
              <p className="text-center text-sm lg:text-md pb-2 text-black">24X7 LMS Access</p>
              <img src={access_I3z9CNv} alt="24X7 LMS Access" className="lg:h-8 h-6" />
            </div>
          </div>
          <div tabindex="0" className='box transform transition-transform duration-300 hover:scale-110'>
            <div className="bg-[#7F56D9] p-5 lg:h-[135px] lg:w-[135px] h-[160px] w-[160px] xl:h-[160px] xl:w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
              <p className="text-center text-sm lg:text-md pb-2 text-white">400+ Bite Size Videos</p>
              <img src={videos_u2JRfHI} alt="400+ Bite Size Videos" className="lg:h-8 h-6" />
            </div>
          </div>
          <div tabindex="0" className='box transform transition-transform duration-300 hover:scale-110'>
            <div className="bg-[#E29E35] p-5 lg:h-[135px] lg:w-[135px] h-[160px] w-[160px] xl:h-[160px] xl:w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
              <p className="text-center text-sm lg:text-md pb-2 text-black">E-Books</p>
              <img src={book_URipUVP} alt="E-Books" className="lg:h-8 h-6" />
            </div>
          </div>
          <div tabindex="0" className='box transform transition-transform duration-300 hover:scale-110'>
            <div className="bg-[#7F56D9] p-5 lg:h-[135px] lg:w-[135px] h-[160px] w-[160px] xl:h-[160px] xl:w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
              <p className="text-center text-sm lg:text-md pb-2 text-white">360+ Hours Live Training</p>
              <img src={live_4eNevXX} alt="360+ Hours Live Training" className="lg:h-8 h-6" />
            </div>
          </div>
          <div tabindex="0" className='box transform transition-transform duration-300 hover:scale-110'>
            <div className="bg-[#E29E35] p-5 lg:h-[135px] lg:w-[135px] h-[160px] w-[160px] xl:h-[160px] xl:w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
              <p className="text-center text-sm lg:text-md pb-2 text-black">100% Placement Support</p>
              <img src={job_ahgewK6} alt="100% Placement Support" className="lg:h-8 h-6" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#fafbff] lg:mt-[-79px] flex items-center justify-center pt-8 lg:pt-7 pb-4 lg:px-12">
        <div className="lg:max-w-6xl gap-0 flex flex-col-reverse lg:flex-row items-center justify-center align-center">

          <div className="relative overflow-hidden" style={{ width: 'fit-content' }}>
            <div style={{ opacity: '1', transform: 'none' }}>
              <div className="relative overflow-hidden flex flex-row items-center justify-center align-center lg:pt-[77px]">
                <div className="mx-auto px-8 sm:px-6 lg:px-8 py-10">
                  <div className="text-center mx-auto">
                    <h2 style={{ lineHeight: '50px' }} className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-3xl md:text-4xl">
                      <span className='uppercase text-xl text-[#7F56D9] mb-[7px]'>Certified Public Accountant (CPA)</span> <span className="text-primary_text mb-3"> A US Certified Accounting, Audit & Tax Professional Course </span></h2>

                    <p className="text-[15px] text-base md:text-medium text-left text-dark_text text-center">US CPA is a globally recognised profession that provides highest accounting, audit and tax credentials. It has worldwide acceptability, with which one can make an international career. In this <Link target='_blank' className='text-[#E29E35]' to="https://www.kcglobed.com/us-cpa-courses">US CPA course </Link> candidate get an expertise in US GAAP (US Generally Accepted Accounting Principles), IFRS (International Financial Reporting Standards), SEC Rules & Regulations and U.S Taxation.</p>
                    <p className="mt-3 text-[15px] text-base md:text-medium text-left text-dark_text  text-center">CPA exams are conducted by NASBA, which is an examination body of American Institute of Certified Public Accountants (AICPA).These exams are uniform across the globe however, candidates need to take admission and fulfil the licensing requirement in any one of the 55 State Board of Accountancy in USA.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 md:p-8 lg:p-10">
        <h2 className="font-sans block mb-16 text-3xl md:text-4xl font-bold text-gray-700  text-center mt-6 lg:mt-0">Why <span className="text-primary_text">Study US CPA</span></h2>
        <div className="flex flex-col items-center">
          <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8  items-center xs:max-w-xl lg:max-w-4xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <img src={whystdy} alt="" className="h-50 w-30 mb-6 lg:pr-10" />
              <div className="flex flex-col mr-6">
                <p className="mb-5 text-[15px] text-base md:text-medium text-left text-dark_text">
                  <img src={greenTickFill} className='w-[19px] inline-block mr-2 float-left' /> Certified and Licensed by AICPA, The World’s Most Renowned Professional Body
                </p>
                <p className="mb-5 text-[15px] text-base md:text-medium text-left text-dark_text">
                  <img src={greenTickFill} className='w-[19px] inline-block mr-2' /> Worldwide Industry Acceptability
                </p>
                <p className="mb-5 text-[15px] text-base md:text-medium text-left text-dark_text">
                  <img src={greenTickFill} className='w-[19px] inline-block mr-2' />Global Career Opportunities for Practice or Job
                </p>
                <p className="mb-5 text-[15px] text-base md:text-medium text-left text-dark_text">
                  <img src={greenTickFill} className='w-[19px] inline-block mr-2' /> Increased Reliability
                </p>
                <p className="mb-5 text-[15px] text-base md:text-medium text-left text-dark_text">
                  <img src={greenTickFill} className='w-[19px] inline-block mr-2' /> Greater Pay Packages
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 md:p-8 lg:p-10">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className="font-sans block mb-6 text-3xl md:text-4xl font-bold text-gray-700  text-center">What We <span className="text-primary_text">Offer?</span></h2>
              </div>
            </div>
          </div>
          <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-4xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <div className="flex flex-col ml-0 lg:ml-6">
                <p className="text-xl font-semibold md:text-2xl mb-4 placeholder gap-1"><span>AI</span><span className="text-gray-500">  Enabled Learning<br /> Management Software (LMS)</span></p>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  Unlimited access until you pass. Our AI powered LMS will help you in identifying the areas you need to focus and build a comprehensive personal study plan to watch expert’s videos, read book, practice MCQs and simulations for your individual needs to help you pass much faster in one go.
                </p>
              </div>
              <img src={aipord1} alt="" className="mt-6 lg:pl-10" />
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 md:p-8 lg:p-10">
        <div className="flex flex-col items-center">
          <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-4xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <img src={Excellence_1} alt="" className="h-50 w-30 mb-6 lg:pr-10" />
              <div className="flex flex-col mr-6">
                <p className="font-semibold text-xl md:text-2xl mb-4 flex flex-row flex-wrap gap-1"><span>Unmatchable</span><span className="text-gray-500"> Counsellor Support</span></p>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">As we all know, there is lots of administrative activities involved in CPA journey like getting transcripts, selecting right state board of accountancy, evaluation of transcripts from NASBA, enrolment with state board of accountancy, examination fee submissions, notice to schedule exam and slot booking with prometriccenter to sit for <Link target='_blank' className='text-[#E29E35]' to="https://www.kcglobed.com/us-cpa-exam-requirements">US CPA exams.</Link></p>
                <p className="mt-3 text-[15px] text-base md:text-medium text-left text-dark_text">You need a buddy to help you in all these administrative needs. We have a dedicated team of counsellor, who will be your buddy in this journey and help you in all processes.</p>
              </div>
            </div>
          </div>
          <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-4xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
              <div className="flex flex-col ml-0 lg:ml-6">
                <p className="text-xl font-semibold md:text-2xl mb-4 placeholder flex flex-row flex-wrap gap-1"><span>100%</span><span className="text-gray-500"> Placement Support</span></p>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  After qualification or even before we provide you 100% placement support in big consulting firms and MNCs across the nation.
                </p>
              </div>
              <img src={Img1} alt="" className="mt-6 lg:pl-10" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#6C38CC] pt-24 pb-20">
        <div className="relative overflow-hidden">
          <div className="max-w-[85rem] mx-auto px-0 sm:px-6 lg:px-8">
            <div className="max-w-3xl text-center mx-auto px-4">
              <h2 className="block mb-3 text-3xl font-bold text-white sm:text-4xl md:text-4xl">Industry Expert’s Live/Virtual Classes</h2>
              <h2 className="block text-2xl text-white font-light">Our instructors are qualified CPAs with extensive industry experience. They empower each student by co-relating theory with their practical experience and make them industry ready.</h2>
            </div>
          </div>
        </div>
        <div className="xl:my-24 lg:max-w-[1250px] md:max-w-[850px] flex px-4 py-5 sm:px-6 lg:px-8 lg:py-14 mx-auto justify-center items-center">
          <div className="grid md:grid-cols-2 lg:scale-[110%] xl:scale-[135%] gap-8 justify-items-center content-center items-center">
            <div className="flex items-end justify-end lg:w-[17rem]">
              <img
                src={Asset_98Testimonials} className="h-auto w-auto -mb-0 md:-mb-2"
              />
            </div>
            <div className="flex items-end justify-end lg:w-[17rem]">
              <img
                src={Asset_96Testimonials} className="h-auto w-auto -mb-0 md:-mb-2"
              />
            </div>
            <div className="flex items-end justify-end lg:w-[17rem]">
              <img
                src={Asset_93Testimonials} className="h-auto w-auto -mb-0 md:-mb-2"
              />
            </div>
            <div className="flex items-end justify-end lg:w-[17rem]">
              <img
                src={Asset_92Testimonials} className="h-auto w-auto -mb-0 md:-mb-2"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-first-step py-10 bg-center bg-no-repeat bg-cover">
        <div className="flex flex-col items-center">
          <div className="relative overflow-hidden">
            <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
              <div className="max-w-3xl text-center mx-auto">
                <h2 className='font-bold text-white text-3xl'>Our Pass Rate is 95% Compared to National Average Records of Passing History is 55%</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="m-auto max-w-6xl pb-20 mt-4">
        <div className=" slogan-bg items-center backdrop-blur-md bg-[#BDD9E7]/30 p-4 lg:p-10 rounded-3xl">
          <div className="flex flex-col gap-2 md:gap-2 lg:gap-2 xl:gap-6 2xl:gap-8 text-lg p-3 mt-0 rounded-xl -mt-4 bg-[#6C38CC]">
            <div className="relative overflow-hidden">
              <div className="flex flex-col gap-1">
                <h2 className="block text-center flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-3xl lg:mt-[21px]  text-white"> US CPA Exams in India</h2>
                <p className='text-[15px] text-base md:text-medium text-center  text-white'>Prometric test centers now in Ahmedabad, Bangalore, Calcutta, Chennai, Hyderabad, Mumbai, New Delhi and Trivandrum.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default CpaCoachingIndia;
